









import {defineComponent} from '@vue/composition-api'

export default defineComponent({
  name: "ImageAtom",
  props: {
    url: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    fallback: {
      type: String,
      validator: (value: string) => {
        // matches a part of the fallback class defined in VU.Web.Assets/Styles/_image.scss
        return ['vulogo', 'actalogo', 'profile'].includes(value)
      }
    }
  },
  setup: (props) => {
    const fallbackClass = `vuw-${props.fallback}-fallback-image`
    let source = props.url ? new URL(props.url) : null;

    if (source) {
      source.searchParams.append("fm", "jpg")
      source.searchParams.append("auto", "format")
    }

    return {
      fallbackClass,
      source
    }
  }
})
